// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { DeclaredCommand, DeclaredCommandT, verifyDeclaredCommand } from "./declared-command";
import { Diagnostic, DiagnosticT, verifyDiagnostic } from "./diagnostic";
import { IdlSummary, IdlSummaryT, verifyIdlSummary } from "./idl-summary";

export class IdlResult implements flatbuffers.IUnpackableObject<IdlResultT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): IdlResult {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsIdlResult(bb: flatbuffers.ByteBuffer, obj?: IdlResult): IdlResult {
    return (obj || new IdlResult()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsIdlResult(bb: flatbuffers.ByteBuffer, obj?: IdlResult): IdlResult {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new IdlResult()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  diagnostics(index: number, obj?: Diagnostic): Diagnostic | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Diagnostic()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  diagnosticsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  summary(obj?: IdlSummary): IdlSummary | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new IdlSummary()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  cdoBinary(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
  }

  cdoBinaryLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  cdoBinaryArray(): Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? new Uint8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset),
        )
      : null;
  }

  canonicalSha256(): string | null;
  canonicalSha256(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  canonicalSha256(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  canonicalFormat(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
  }

  schemaFingerprint(): string | null;
  schemaFingerprint(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  schemaFingerprint(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  canaryOk(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  inflated(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
  }

  inflatedLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  inflatedArray(): Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset
      ? new Uint8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset),
        )
      : null;
  }

  commands(index: number, obj?: DeclaredCommand): DeclaredCommand | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset
      ? (obj || new DeclaredCommand()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  commandsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startIdlResult(builder: flatbuffers.Builder) {
    builder.startObject(9);
  }

  static addDiagnostics(builder: flatbuffers.Builder, diagnosticsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, diagnosticsOffset, 0);
  }

  static createDiagnosticsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startDiagnosticsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addSummary(builder: flatbuffers.Builder, summaryOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, summaryOffset, 0);
  }

  static addCdoBinary(builder: flatbuffers.Builder, cdoBinaryOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, cdoBinaryOffset, 0);
  }

  static createCdoBinaryVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startCdoBinaryVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addCanonicalSha256(
    builder: flatbuffers.Builder,
    canonicalSha256Offset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(3, canonicalSha256Offset, 0);
  }

  static addCanonicalFormat(builder: flatbuffers.Builder, canonicalFormat: number) {
    builder.addFieldInt16(4, canonicalFormat, 0);
  }

  static addSchemaFingerprint(
    builder: flatbuffers.Builder,
    schemaFingerprintOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(5, schemaFingerprintOffset, 0);
  }

  static addCanaryOk(builder: flatbuffers.Builder, canaryOk: boolean) {
    builder.addFieldInt8(6, +canaryOk, +false);
  }

  static addInflated(builder: flatbuffers.Builder, inflatedOffset: flatbuffers.Offset) {
    builder.addFieldOffset(7, inflatedOffset, 0);
  }

  static createInflatedVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startInflatedVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addCommands(builder: flatbuffers.Builder, commandsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(8, commandsOffset, 0);
  }

  static createCommandsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startCommandsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endIdlResult(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  unpack(): IdlResultT {
    return new IdlResultT(
      this.bb!.createObjList<Diagnostic, DiagnosticT>(
        this.diagnostics.bind(this),
        this.diagnosticsLength(),
      ),
      this.summary() !== null ? this.summary()!.unpack() : null,
      this.bb!.createScalarList<number>(this.cdoBinary.bind(this), this.cdoBinaryLength()),
      this.canonicalSha256(),
      this.canonicalFormat(),
      this.schemaFingerprint(),
      this.canaryOk(),
      this.bb!.createScalarList<number>(this.inflated.bind(this), this.inflatedLength()),
      this.bb!.createObjList<DeclaredCommand, DeclaredCommandT>(
        this.commands.bind(this),
        this.commandsLength(),
      ),
    );
  }

  unpackTo(_o: IdlResultT): void {
    _o.diagnostics = this.bb!.createObjList<Diagnostic, DiagnosticT>(
      this.diagnostics.bind(this),
      this.diagnosticsLength(),
    );
    _o.summary = this.summary() !== null ? this.summary()!.unpack() : null;
    _o.cdoBinary = this.bb!.createScalarList<number>(
      this.cdoBinary.bind(this),
      this.cdoBinaryLength(),
    );
    _o.canonicalSha256 = this.canonicalSha256();
    _o.canonicalFormat = this.canonicalFormat();
    _o.schemaFingerprint = this.schemaFingerprint();
    _o.canaryOk = this.canaryOk();
    _o.inflated = this.bb!.createScalarList<number>(
      this.inflated.bind(this),
      this.inflatedLength(),
    );
    _o.commands = this.bb!.createObjList<DeclaredCommand, DeclaredCommandT>(
      this.commands.bind(this),
      this.commandsLength(),
    );
  }

  unpackFields(...fields: string[]): IdlResultT {
    const t = new IdlResultT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("diagnostics")) {
      t.diagnostics = this.bb!.createObjList<Diagnostic, DiagnosticT>(
        this.diagnostics.bind(this),
        this.diagnosticsLength(),
      );
    }
    if (fieldSet.has("summary")) {
      t.summary = this.summary() !== null ? this.summary()!.unpack() : null;
    }
    if (fieldSet.has("cdo_binary")) {
      t.cdoBinary = this.bb!.createScalarList<number>(
        this.cdoBinary.bind(this),
        this.cdoBinaryLength(),
      );
    }
    if (fieldSet.has("canonical_sha256")) {
      t.canonicalSha256 = this.canonicalSha256();
    }
    if (fieldSet.has("canonical_format")) {
      t.canonicalFormat = this.canonicalFormat();
    }
    if (fieldSet.has("schema_fingerprint")) {
      t.schemaFingerprint = this.schemaFingerprint();
    }
    if (fieldSet.has("canary_ok")) {
      t.canaryOk = this.canaryOk();
    }
    if (fieldSet.has("inflated")) {
      t.inflated = this.bb!.createScalarList<number>(
        this.inflated.bind(this),
        this.inflatedLength(),
      );
    }
    if (fieldSet.has("commands")) {
      t.commands = this.bb!.createObjList<DeclaredCommand, DeclaredCommandT>(
        this.commands.bind(this),
        this.commandsLength(),
      );
    }
    return t;
  }
}

export class IdlResultT implements flatbuffers.IGeneratedObject {
  constructor(
    public diagnostics: DiagnosticT[] = [],
    public summary: IdlSummaryT | null = null,
    public cdoBinary: number[] = [],
    public canonicalSha256: string | Uint8Array | null = null,
    public canonicalFormat: number = 0,
    public schemaFingerprint: string | Uint8Array | null = null,
    public canaryOk: boolean = false,
    public inflated: number[] = [],
    public commands: DeclaredCommandT[] = [],
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const diagnostics = IdlResult.createDiagnosticsVector(
      builder,
      builder.createObjectOffsetList(this.diagnostics),
    );
    const summary = this.summary !== null ? this.summary!.pack(builder) : 0;
    const cdoBinary = IdlResult.createCdoBinaryVector(builder, this.cdoBinary);
    const canonicalSha256 =
      this.canonicalSha256 !== null ? builder.createString(this.canonicalSha256!) : 0;
    const schemaFingerprint =
      this.schemaFingerprint !== null ? builder.createString(this.schemaFingerprint!) : 0;
    const inflated = IdlResult.createInflatedVector(builder, this.inflated);
    const commands = IdlResult.createCommandsVector(
      builder,
      builder.createObjectOffsetList(this.commands),
    );

    IdlResult.startIdlResult(builder);
    IdlResult.addDiagnostics(builder, diagnostics);
    IdlResult.addSummary(builder, summary);
    IdlResult.addCdoBinary(builder, cdoBinary);
    IdlResult.addCanonicalSha256(builder, canonicalSha256);
    IdlResult.addCanonicalFormat(builder, this.canonicalFormat);
    IdlResult.addSchemaFingerprint(builder, schemaFingerprint);
    IdlResult.addCanaryOk(builder, this.canaryOk);
    IdlResult.addInflated(builder, inflated);
    IdlResult.addCommands(builder, commands);

    return IdlResult.endIdlResult(builder);
  }

  clone(): IdlResultT {
    const obj = new IdlResultT();
    obj.diagnostics = this.diagnostics.map((e) => e.clone());
    obj.summary = this.summary !== null ? this.summary!.clone() : null;
    obj.cdoBinary = [...this.cdoBinary];
    obj.canonicalSha256 = this.canonicalSha256;
    obj.canonicalFormat = this.canonicalFormat;
    obj.schemaFingerprint = this.schemaFingerprint;
    obj.canaryOk = this.canaryOk;
    obj.inflated = [...this.inflated];
    obj.commands = this.commands.map((e) => e.clone());
    return obj;
  }

  equals(other: IdlResultT): boolean {
    if (this.diagnostics.length !== other.diagnostics.length) return false;
    for (let i = 0; i < this.diagnostics.length; i++) {
      const a = this.diagnostics[i];
      const b = other.diagnostics[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.summary !== null && other.summary !== null) {
      if (!this.summary!.equals(other.summary!)) return false;
    } else if (this.summary !== other.summary) return false;
    if (this.cdoBinary.length !== other.cdoBinary.length) return false;
    for (let i = 0; i < this.cdoBinary.length; i++) {
      if (this.cdoBinary[i] !== other.cdoBinary[i]) return false;
    }
    if (this.canonicalSha256 !== other.canonicalSha256) return false;
    if (this.canonicalFormat !== other.canonicalFormat) return false;
    if (this.schemaFingerprint !== other.schemaFingerprint) return false;
    if (this.canaryOk !== other.canaryOk) return false;
    if (this.inflated.length !== other.inflated.length) return false;
    for (let i = 0; i < this.inflated.length; i++) {
      if (this.inflated[i] !== other.inflated[i]) return false;
    }
    if (this.commands.length !== other.commands.length) return false;
    for (let i = 0; i < this.commands.length; i++) {
      const a = this.commands[i];
      const b = other.commands[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifyIdlResult(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyDiagnostic);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyIdlSummary(verifier, fieldPos + tableOffset);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 12, 2);
    {
      const pos = verifier.checkOffsetField(tablePos, 14);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 16, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 18);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 20);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyDeclaredCommand);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
